import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-n', 'LetterN', [["path",{"d":"M7 20v-16l10 16v-16"}]]);